import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { useNavigate } from 'react-router-dom';
import styles from './reactLink.scss';

const ReactLink = ({ className, to, children, onClick }) => {
  const isExternalUrl = typeof to === 'string' && /^(?:https?:)?\/\//i.test(to);
  const auth = useAuth0();
  const isAuthenticated = auth?.isAuthenticated;
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(to || '');

    onClick && onClick();
  };

  if (isExternalUrl) {
    return (
      <a
        className={className}
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  if (!isExternalUrl) {
    const toToJs = to && to.toJS ? to.toJS() : to;
    return (
      <ReactRouterLink
        onClick={handleClick}
        className={className}
        to={toToJs || ''}
      >
        {children}
      </ReactRouterLink>
    );
  }

  return null;
};

ReactLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  state: PropTypes.object,
  onClick: PropTypes.func,
};

export default ReactLink;
